import { FC } from 'react';

import { INITIATOR, Offer, OFFER_STATUS } from 'types';
import { formatPrice } from 'utils/text-helpers';

type Price = {
  priceCents: number;
  initiator: INITIATOR;
};

type PriceHistoryItemProps = {
  price: Price;
  idx: number;
  offer: Offer;
  mostRecentIsBuyer: boolean;
  isSeller?: boolean;
  priceHistory: Price[];
};

export const PriceHistoryItem: FC<PriceHistoryItemProps> = ({
  price,
  idx,
  offer,
  isSeller,
  mostRecentIsBuyer,
  priceHistory
}) => (
  <div key={`priceHistory-${idx}-${price.priceCents}`} className='mb-4'>
    {idx % 2 === (isSeller ? 1 : 0) && (
      <div className='row justify-content-end m-0 mb-4'>
        <div className='riforma-regular fs-12px text-secondary px-1 text-end mb-1'>You</div>
        <div className='bg-primary rounded-2 w-sm-auto w-60 text-center px-5 py-3'>
          <div className='text-secondary text-uppercase fs-12px line-height-16px mb-2 letter-spacing-1'>
            Your {idx === 0 ? 'offer' : 'counter'}
          </div>
          <div className='text-white riforma-light fs-24px line-height-32px opacity-90 letter-spacing-2'>
            {formatPrice(price.priceCents)}
          </div>
        </div>
      </div>
    )}
    {idx % 2 === (isSeller ? 0 : 1) && (
      <div className='row justify-content-beginning m-0 mb-4'>
        <div className='riforma-regular fs-12px text-secondary px-1 text-start mb-1'>
          {isSeller ? 'Buyer' : 'Seller'}
        </div>
        <div className='bg-lightPrimaryBackground border rounded-2 w-sm-auto w-60 text-center px-5 py-3'>
          <div className='text-secondary text-uppercase fs-12px line-height-16px mb-2 letter-spacing-1'>
            {isSeller ? 'Buyer offer' : 'Seller offer'}
          </div>
          <div className='text-primary riforma-light fs-24px line-height-32px opacity-90 letter-spacing-2'>
            {formatPrice(price.priceCents)}
          </div>
        </div>
      </div>
    )}
    {idx === priceHistory.length - 1 && offer.status === OFFER_STATUS.ACCEPTED && (
      <div className={`row m-0 justify-content-${mostRecentIsBuyer ? 'beginning' : 'end'}`}>
        <div
          className={`riforma-regular fs-12px text-secondary px-1 opacity-60 mb-1 text-${
            mostRecentIsBuyer ? 'start' : 'end'
          }`}
        >
          {mostRecentIsBuyer ? 'Seller' : 'You'}
        </div>
        <div className='bg-lightSuccess border rounded-2 w-sm-auto w-60 text-center px-5 py-3'>
          <div className='text-success text-uppercase fs-12px line-height-16px mb-2 letter-spacing-1'>Accepted</div>
          <div className='text-success riforma-light fs-24px line-height-32px opacity-90 letter-spacing-2'>
            {formatPrice(price.priceCents)}
          </div>
        </div>
      </div>
    )}
  </div>
);
